import { render, staticRenderFns } from "./InvoicesModule.vue?vue&type=template&id=dd7d64be"
import script from "./InvoicesModule.vue?vue&type=script&lang=js"
export * from "./InvoicesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports